import { IconFileDocument, IconFilePDF, IconFileSpreadsheet, IconFilePresentation, IconFileImage, IconFileAudio, IconFileVideo, IconDocumentFilled } from '@hubble/icons';
import { jsx } from '@emotion/react/jsx-runtime';

const AUDIO_EXTENSIONS = ['3gp', 'aa', 'aac', 'aax', 'act', 'aiff', 'alac', 'ape', 'au', 'awb', 'dss', 'dvf', 'flac', 'gsm', 'iklax', 'ivs', 'm4a', 'm4b', 'm4b', 'mmf', 'mp3', 'msv', 'mpc', 'nmf', 'oog', 'oga', 'opus', 'ra', 'rm', 'rf64', 'sln', 'tta', 'voc', 'vox', 'wav', 'wma', 'wv', 'webm', '8svx', 'cda'];
const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'tiff', 'psd', 'raw', 'bmp', 'heif', 'bmp', 'psd', 'indd', 'svg', 'ai', 'eps'];
const VIDEO_EXTENSIONS = ['mp4', 'mov', 'wmv', 'avi', 'avchd', 'flv', 'f4v', 'swf', 'mkv', 'webm', 'mpg', 'mpeg', 'm2v', 'vob', 'gifv', 'qt', 'amv'];
const PRESENTATION_EXTENSIONS = ['pptx', 'pptm', 'ppt', 'potx', 'potm', 'pot', 'thmx', 'ppsx', 'ppsm', 'pps'];
const SPREADSHEET_EXTENSIONS = ['xls', 'xlsx', 'ods', 'sxc', 'dif', 'dat', 'csv', 'tsv', 'numbers'];
const PDF_EXTENSIONS = ['pdf'];
const DOCUMENT_EXTENSIONS = ['doc', 'docx', 'dot', 'dotm', 'dotx'];
const DEFAULT_EXTENSIONS = ['default'];
const FILE_ICON_MAP = {
  document: {
    extensions: DOCUMENT_EXTENSIONS,
    icon: jsx(IconFileDocument, {})
  },
  pdf: {
    extensions: PDF_EXTENSIONS,
    icon: jsx(IconFilePDF, {})
  },
  spreadsheet: {
    extensions: SPREADSHEET_EXTENSIONS,
    icon: jsx(IconFileSpreadsheet, {})
  },
  presentation: {
    extensions: PRESENTATION_EXTENSIONS,
    icon: jsx(IconFilePresentation, {})
  },
  image: {
    extensions: IMAGE_EXTENSIONS,
    icon: jsx(IconFileImage, {})
  },
  audio: {
    extensions: AUDIO_EXTENSIONS,
    icon: jsx(IconFileAudio, {})
  },
  video: {
    extensions: VIDEO_EXTENSIONS,
    icon: jsx(IconFileVideo, {})
  },
  default: {
    extensions: DEFAULT_EXTENSIONS,
    icon: jsx(IconDocumentFilled, {})
  }
};

export { AUDIO_EXTENSIONS, DEFAULT_EXTENSIONS, DOCUMENT_EXTENSIONS, FILE_ICON_MAP, IMAGE_EXTENSIONS, PDF_EXTENSIONS, PRESENTATION_EXTENSIONS, SPREADSHEET_EXTENSIONS, VIDEO_EXTENSIONS };
